<template>
  <header class="header" :class="{ 'd-none d-lg-flex': !current_title }">
    <div class="container-fluid">
      <!-- <pre>{{ current_brand }}</pre> -->
      <div class="row align-items-center d-none d-md-flex">
        <div class="col-5 col-lg-3">
          <div class="header__branding">
            <router-link :data-brand="site.id" to="/">
              <div v-if="site.id == 'BRI'">
                <img
                  :class="`logo--BRI`"
                  src="https://shineraychile.cl/content/uploads/2023/09/logo-shineray-negro.png"
                  alt="logo--${site.id}"
                />
              </div>
              <div v-else>
                <logo
                  :class="`logo--${site.id}`"
                  :logo="current_brand.logo"
                ></logo>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-1 col-lg-6">
          <div class="d-none d-lg-block">
            <Progress v-if="current_step > 0" />
          </div>
        </div>
        <div class="col-6 col-lg-3">
          <div class="header__reset">
            <a
              v-if="site.label"
              class="site-external"
              :href="site.url"
              target="_blank"
              rel="noopener"
              >{{ site.label }} <i class="material-icons">exit_to_app</i></a
            >
            <button class="button button--text text-danger" @click="logoutUser">
              <i class="button__icon material-icons">power_settings_new</i>
              <span class="button__text">Salir</span>
            </button>
          </div>
        </div>
      </div>
      <div class="header-mobile d-md-none">
        <a
          class="button button--back pr-3"
          href="#"
          @click.prevent="$router.go(-1)"
        >
          <i class="button__icon material-icons">arrow_back</i>
          <span class="button__text">{{ current_title }}</span>
        </a>
        <button
          class="header-mobile__menu button"
          :class="{ 'header-mobile__menu--active': showMenu }"
          @click="toggleMenu"
        >
          <span class="button__text" v-if="showMenu">Cerrar</span>
          <i
            class="button__icon material-icons"
            v-text="showMenu ? 'close' : 'menu'"
          ></i>
        </button>
      </div>
    </div>

    <app-mobile
      v-if="showMenu"
      @close="toggleMenu(false)"
      :site="site"
    ></app-mobile>
  </header>
</template>

<script>
import Logo from '@/components/Logo';
import Progress from '@/components/Progress';
import AppMobile from '@/components/AppMobile';

import { mapState } from 'vuex';

export default {
  name: 'AppHeader',
  components: {
    Logo,
    Progress,
    AppMobile,
  },
  data() {
    return {
      site: {
        id: process.env.VUE_APP_BRAND_ID || '',
        label: process.env.VUE_APP_BRAND_SITE_LABEL || '',
        url: process.env.VUE_APP_BRAND_SITE_URL || '',
      },
      showMenu: false,
    };
  },
  computed: {
    ...mapState(['current_brand', 'current_step', 'current_title']),
  },
  methods: {
    logoutUser() {
      this.toggleMenu(false);
      this.$store
        .dispatch('logoutUser')
        .then(() => this.$router.push({ name: 'login' }))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido desconectar tu cuenta',
          });
        });
    },
    toggleMenu($event, value) {
      if (value) {
        return (this.showMenu = value);
      }

      this.showMenu = !this.showMenu;
    },
  },
};
</script>
